
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { api } from "../../api/client";

// Fetch bets for a particular match
export const fetchMatchBets = createAsyncThunk(
  "matchBets/fetchMatchBets",
  async ({ userId, matchId, sport }, { rejectWithValue }) => {
    try {
      const res = await api.get(`/user-history/match/bets`, {
        params: { userId, matchId, sport }
      });
      return res.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || { message: "Failed to fetch match bets" });
    }
  }
);

// Fetch bets for a particular match
export const fetchMatchBetDetails = createAsyncThunk(
  "matchBets/fetchMatchBetDetails",
  async ({userId,matchId,selection }, { rejectWithValue }) => {
    try {
      const res = await api.get(`/user-history/match/bets/detail`, {
        params: { userId, matchId,selection }
      });
      return res.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || { message: "Failed to fetch match bets" });
    }
  }
);

const matchBetsSlice = createSlice({
  name: "matchBets",
  initialState: {
    bets: [],
    betDetails: [],
    loading: false,
    error: null,
  },
  reducers: {
    clearMatchBets: (state) => {
      state.bets = [];
      state.betDetails = [];
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchMatchBets.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchMatchBets.fulfilled, (state, action) => {
        state.loading = false;
        state.bets = action.payload.bets || [];
        // state.totalPl = action.payload.totalPl || 0;
      })
      .addCase(fetchMatchBets.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload?.message || "Error fetching match bets";
      })

      // --- Fetch Detailed Bets ---
      .addCase(fetchMatchBetDetails.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchMatchBetDetails.fulfilled, (state, action) => {
        state.loading = false;
        state.betDetails = Array.isArray(action.payload)
          ? action.payload
          : [action.payload]; 
      })


      .addCase(fetchMatchBetDetails.rejected, (state, action) => {
        state.loading = false;
        state.error =
          action.payload?.message || "Error fetching bet details";
      });
  },
});

export const { clearMatchBets } = matchBetsSlice.actions;
export default matchBetsSlice.reducer;
